import { Button, FormInput, FormRoot, RHF, zodResolver } from "@devhop/ui";
import { z } from "zod";
import { config } from "@/shared/lib/config";
import { fetchLookupForInfinite, hydrateLookupItem } from "@/shared/lib/utils";
import { FormInfiniteCombobox } from "@/shared/ui/FormInfiniteCombobox";

type UserItem = { id: string; name: string };

const DepartmentFormSchema = z.object({
  name: z.string().min(1, "ກະລຸນາໃສ່ຊື່ພະແນກ"),
  managerId: z
    .union([z.string(), z.null()])
    .transform((val) => (val === "" ? null : val))
    .nullable()
    .optional(),
});
export type DepartmentFormValues = z.infer<typeof DepartmentFormSchema>;

export function DepartmentForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues?: Partial<DepartmentFormValues>;
  onSubmit: (values: DepartmentFormValues) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<DepartmentFormValues>({
    resolver: zodResolver(DepartmentFormSchema),
    defaultValues: {
      name: "",
      managerId: null,
      ...initialValues,
    },
  });

  return (
    <FormRoot<DepartmentFormValues>
      methods={methods}
      onSubmit={onSubmit}
      className="space-y-4"
    >
      <div className="min-w-0 max-w-full">
        <FormInput
          name="name"
          label="ຊື່ພະແນກ"
          requiredMark
          placeholder="ຕົວຢ່າງ: ພະແນກ IT, ພະແນກ HR"
        />
      </div>
      <div className="min-w-0 max-w-full">
        <FormInfiniteCombobox<UserItem>
          name="managerId"
          label="ຫົວໜ້າພະແນກ"
          queryKey={["users"]}
          queryFn={(args) =>
            fetchLookupForInfinite(
              `${config.apiUrl}/departments/users/lookup`,
              args,
            )
          }
          preloadQueryFn={(id) =>
            hydrateLookupItem(`${config.apiUrl}/departments/users/lookup`, id)
          }
          getLabel={(item) => item.name}
          getValue={(item) => item.id}
          placeholder="ເລືອກຫົວໜ້າພະແນກ (ບໍ່ບັງຄັບ)"
          clearable
        />
      </div>

      <div className="flex justify-end gap-2">
        <Button type="submit" isLoading={submitting}>
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
